module.exports = __webpack_public_path__ + "static/media/correct.90fd2d37.svg";